import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import ConfiguracionUsuario from './Componentes/ConfiguracionUsuario';

export default function ConfigUser() {
    
    return (
        <MainContent component={ <ConfiguracionUsuario /> } titulo='Configuración de Usuario' />           
    );
};